import { useState } from "react";

const FAQS = [
  {
    q: "What is your minimum order quantity (MOQ)?",
    a: "Our minimum order quantity starts at 20 pieces per design.",
  },
  {
    q: "Do you help with design or do we need final artwork?",
    a: "Yes, our design team can assist you end-to-end.",
  },
  {
    q: "Will we see a design preview before production starts?",
    a: "Production begins only after your final approval.",
  },
  {
    q: "What printing and customization techniques do you use?",
    a: "We use DTG, screen printing, embroidery and premium finishes.",
  },
  {
    q: "How long does production usually take?",
    a: "Typically 7–10 working days after approval.",
  },
  {
    q: "Do you ship across India?",
    a: "Yes, we ship PAN India.",
  },
];

const ACTIVE_COLOR = "#FE7814";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="w-full bg-black text-white">
      <div
        className="mx-auto"
        style={{
          maxWidth: "1100px",
          paddingLeft: "2vw",   //  4% left
          paddingRight: "2vw",  //  4% right
          paddingTop: "6vh",
          paddingBottom: "6vh",
        }}
      >
        {/* ===== TITLE ===== */}
        <div className="text-center mb-[10vh]">
          <h2
  style={{
    fontFamily: "'PP Neue Montreal', sans-serif",
    fontWeight: 400,
    fontSize: "clamp(36px, 4.5vw, 60px)",
    lineHeight: "1.18",
    letterSpacing: "0.05em", // slightly tighter for bold
    
    color: "#fbf8f8",
  }}
>
  <span style={{ display: "block" }}>Questions You</span>
  <span style={{ display: "block" }}> Might Have</span>
  
</h2>
        </div>

        {/* ===== FAQ LIST ===== */}
        <div className="flex flex-col gap-8">
          {FAQS.map((item, i) => {
            const isOpen = open === i;

            return (
              <div key={i} className="w-full">
                {/* QUESTION (RIGHT ALIGNED AS BEFORE) */}
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full md:w-[56%] md:ml-auto flex items-center justify-between transition-all"
                  style={{
                    backgroundColor: isOpen ? ACTIVE_COLOR : "#1e1e1e",
                    color: isOpen ? "#000" : "#E5E7EB",
                    padding: "clamp(14px, 2vh, 20px) clamp(18px, 3vw, 36px)",
                    fontSize: "clamp(14px, 1.4vw, 18px)",
                    borderRadius: "14px 14px 0 14px",
                  }}
                >
                  <span className="text-left">{item.q}</span>
                  <span className="text-2xl font-light">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                {/* ANSWER (⬅️ LEFT ALIGNED NOW) */}
                {isOpen && (
                  <div
                    className="mt-6 grid grid-cols-[56px_1fr] gap-4 items-start"
                    style={{
                      maxWidth: "640px",
                    }}
                  >
                    {/* ICON */}
                    <div className="w-[56px] h-[56px] rounded-full bg-white border-2 border-[#FE7814] flex items-center justify-center">
                      <img
                        src="/chat.png"
                        alt=""
                        className="w-full h-full object-contain scale-125"
                      />
                    </div>

                    {/* ANSWER BUBBLE */}
                    <div
                      className="bg-white text-black shadow-lg"
                      style={{
                        padding:
                          "clamp(16px, 2.4vh, 26px) clamp(18px, 3vw, 32px)",
                        fontSize: "clamp(14px, 1.4vw, 18px)",
                        lineHeight: 1.6,
                        borderRadius: "14px 14px 14px 0",
                      }}
                    >
                      {item.a}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* ===== WHATSAPP CTA ===== */}
        <div
  className="mt-[12vh] flex"
  style={{ paddingLeft: "0vw" }}  // aligns with rest of section
>

         <a
  href="https://wa.me/918080907304?text=Hey%20I%20Have%20a%20query"
  target="_blank"
  rel="noopener noreferrer"
  className="
    inline-flex items-center gap-3
    relative overflow-hidden z-10
    transition-all duration-300 hover:shadow-lg
    after:absolute after:bottom-0 after:left-5 after:h-1 after:w-1
    after:bg-orange-700 after:rounded-md after:-z-10
    after:translate-y-full
    after:transition-all after:duration-700
    hover:after:scale-[300]
  "
  style={{
    backgroundColor: ACTIVE_COLOR,
    color: "#000",
    padding: "16px 32px",
    fontSize: "18px",
  }}
>
  WhatsApp Us for any other Query
</a>


        </div>
      </div>
    </section>
  );
}
